module.exports = __webpack_public_path__ + "img/9.877a6ea7.jpeg";